var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"radio"},_vm._l((_vm.options),function(label,loopValue,i){return _c('g-button',{key:loopValue,class:_vm.getOptionClasses(loopValue, i),on:{"click":function($event){_vm.handleClick(loopValue)}}},[_vm._v(_vm._s(label))])}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f9c2a75e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RadioButton.vue
// module id = 44
// module chunks = 0